import Select, { createFilter } from 'react-select';
import "react-widgets/styles.css";
import { customStyles } from '../data/MochaData';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from './Tooltip'
import { Loading } from '.'

const DropDown = ({
    field = '',
    label = '',
    valueSelect = '',
    dataProvider = [],
    onChangeSelect = () => { },
    isRequired = true,
    hasDescription = false,
    id = '',
    readonly = false,
    useToolTip = false,
    textToolTip = '',
    titleToolTip = '',
    loading = false,
    loadingText = 'Cargando...'
}: IPropsDropdown) => {
    let [val, setVal] = useState({});
    let [cat, setCatalog] = useState(dataProvider);

    const ChangeDropDown = (newValue: any, actionMeta: any) => {
        setVal(newValue);
        onChangeSelect(actionMeta.name, newValue.value);
    }
    useEffect(() => {
        var c = cat.find((x: any) => x.value === valueSelect.toString()) != null ? cat.find((x: any) => x.value === valueSelect.toString()) : null
        setVal(c)
    }, [])

    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
    };

    return (
        <>
            <div className='lbl-input-vida-cr mt-10 mb-5' style={{ display: "flex" }}>
                <span >{label} {isRequired && label.length > 0 && <span style={{ color: '#4D4D4D' }}>*</span>}</span>
                {useToolTip && <Tooltip id={field} key={field} text={textToolTip} title={titleToolTip} />}
            </div>
            {loading ?
                <Loading placeholder={loadingText} />
                :
                <Select
                    id={id}
                    className='w100 mb-20'
                    name={field}
                    options={dataProvider}
                    getOptionLabel={(x: any) => hasDescription ? `${x.description}` : x.text}
                    getOptionValue={(x: any) => x.value}
                    //value={dataProvider.find((x: any) => x.value === valueSelect) != null ? dataProvider.find((x: any) => x.value === valueSelect) : null}
                    value={val}
                    placeholder='Seleccionar'
                    onChange={ChangeDropDown}
                    isSearchable={true}
                    styles={customStyles}
                    defaultValue={val}
                    //isClearable
                    filterOption={createFilter(filterConfig)}
                    controlShouldRenderValue={true}
                    autoFocus
                    isDisabled={readonly}
                />
            }
            <input
                className='input-required'
                value={valueSelect}
                tabIndex={-1}
                autoComplete='off'
                style={{ opacity: 0, height: 0 }}
                required={isRequired}
            />
        </>
    );
}

export { DropDown };